var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8424 6.15796H6.1582V19.8422H19.8424V6.15796Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8422 26L26.0001 19.8421L22.9212 19.3168L19.8422 19.8421L19.2803 22.6584L19.8422 26Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.8421V23.9474C0 25.0814 0.918553 26 2.05263 26H6.1579L6.79015 22.921L6.1579 19.8421L2.80304 19.3168L0 19.8421Z",
    fill: "#188038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 6.15789V2.05263C26.0001 0.918552 25.0816 0 23.9475 0H19.8422C19.4676 1.52708 19.2803 2.65089 19.2803 3.37144C19.2803 4.09199 19.4676 5.02081 19.8422 6.15789C21.2042 6.54788 22.2305 6.74288 22.9212 6.74288C23.6119 6.74288 24.6382 6.54788 26.0001 6.15789Z",
    fill: "#1967D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 6.15796H19.8418V19.8422H25.9997V6.15796Z",
    fill: "#FBBC04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8424 19.842H6.1582V25.9999H19.8424V19.842Z",
    fill: "#34A853"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8421 0H2.05263C0.918553 0 0 0.918553 0 2.05263V19.8421H6.1579V6.1579H19.8421V0Z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96507 16.7734C8.45362 16.4279 8.09954 15.9233 7.90625 15.2562L9.09336 14.7669C9.20112 15.1775 9.38928 15.4956 9.65783 15.7214C9.92467 15.9472 10.2497 16.0584 10.6294 16.0584C11.0177 16.0584 11.3513 15.9404 11.6301 15.7043C11.9089 15.4683 12.0491 15.1672 12.0491 14.8029C12.0491 14.43 11.902 14.1255 11.6078 13.8895C11.3136 13.6534 10.9441 13.5354 10.5028 13.5354H9.81691V12.3602H10.4327C10.8124 12.3602 11.1323 12.2576 11.3923 12.0523C11.6523 11.8471 11.7823 11.5666 11.7823 11.2091C11.7823 10.8909 11.666 10.6377 11.4334 10.4479C11.2007 10.258 10.9065 10.1622 10.549 10.1622C10.2001 10.1622 9.92296 10.2546 9.7177 10.441C9.51257 10.628 9.35835 10.864 9.26954 11.127L8.09441 10.6377C8.25007 10.1964 8.53572 9.80642 8.9548 9.46945C9.37388 9.13248 9.90928 8.96313 10.5593 8.96313C11.0399 8.96313 11.4727 9.0555 11.8559 9.24195C12.239 9.4284 12.5401 9.68669 12.7573 10.0151C12.9745 10.3452 13.0823 10.7147 13.0823 11.1252C13.0823 11.5443 12.9814 11.8984 12.7795 12.1892C12.5777 12.48 12.3297 12.7023 12.0355 12.858V12.9281C12.4154 13.0848 12.7454 13.342 12.9899 13.6722C13.238 14.0058 13.3628 14.4043 13.3628 14.8696C13.3628 15.3348 13.2448 15.7505 13.0088 16.1148C12.7727 16.4792 12.446 16.7666 12.032 16.9752C11.6164 17.1839 11.1494 17.29 10.6311 17.29C10.0307 17.2917 9.47651 17.1189 8.96507 16.7734ZM16.257 10.8823L14.9536 11.8248L14.3019 10.8362L16.6402 9.14958H17.5365V17.1052H16.257V10.8823Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.7e8fdb817c2a40acd63e513ad546257a.svg";
export { ForwardRef as ReactComponent };